export default "__VITE_PUBLIC_ASSET__057e9784__"